export function is_empty(value) {
   return (!value || value === '') ? true : false
}

export function is_email(email) {
   if(is_empty(email)) return false
   var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
   return re.test(email)
}


export function is_fullname(name) {
   if(is_empty(name)) return false
   var re = /[a-záàâãéèêíïóôõöúçñ]\s[a-záàâãéèêíïóôõöúçñ]/gim
   return re.test(name)
}

export function is_gender(gender) {
   if(is_empty(gender)) return false
   if(gender !== 'm' && gender !== 'f') return false

   return true
}

export function is_date(s) {
   if(!s) return false

   var dateFormat = /^\d{1,4}[.|/|-]\d{1,2}[.|/|-]\d{1,4}$/;

   
   if (dateFormat.test(s)) {
       // remove any leading zeros from date values

       s = s.replace(/0*(\d*)/gi,"$1");
       var dateArray = s.split(/[.|/|-]/);
       
               // correct month value
       dateArray[1] = dateArray[1]-1;
       dateArray[2] = parseInt(dateArray[2], 10)
       dateArray[0] = parseInt(dateArray[0], 10)

       // correct year value
       if (dateArray[0].length < 4) {
           // correct year value
           dateArray[0] = (dateArray[0] < 50) ? 2000 + dateArray[0] : 1900 + dateArray[0]
       }

       var testDate = new Date(dateArray[0], dateArray[1], dateArray[2]);

       
       if (testDate.getDate() !== dateArray[2] || testDate.getMonth() !== dateArray[1] || testDate.getFullYear() !== dateArray[0]) {
           return false;
       } else {
           return true;
       }
   } else {
       return false;
   }
}

export function cpf(strCPF) {
    strCPF = strCPF.replace(/[^0-9]/g,'')

    var Soma;
    var Resto;
    Soma = 0;
    if (strCPF === "00000000000") return false;
     
    for (var i=1; i<=9; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i), 10) * (11 - i);
    Resto = (Soma * 10) % 11;
     
    if ((Resto === 10) || (Resto === 11))  Resto = 0;
    if (Resto !== parseInt(strCPF.substring(9, 10), 10) ) return false;
     
    Soma = 0;
    for (i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i), 10) * (12 - i);
    Resto = (Soma * 10) % 11;
     
    if ((Resto === 10) || (Resto === 11))  Resto = 0;
    if (Resto !== parseInt(strCPF.substring(10, 11),10)) return false;
    return true;
}


// WEBPACK FOOTER //
// ./src/SPRINTA/helpers/Validate.js